import { render, staticRenderFns } from "./CoUpcomingEventsWidget.vue?vue&type=template&id=08070dc2&scoped=true&"
import script from "./CoUpcomingEventsWidget.vue?vue&type=script&lang=ts&"
export * from "./CoUpcomingEventsWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CoUpcomingEventsWidget.vue?vue&type=style&index=0&id=08070dc2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08070dc2",
  null
  
)

export default component.exports